module.exports = __webpack_public_path__ + "img/red-circle-close.6a389244.svg";